export default __webpack_public_path__ + "static/media/PrivacyPolicy.d29f9aee.pdf";